module.exports = __webpack_public_path__ + "img/igreja-senhor-do-bonfim.d076dc9e.jpg";